import React from "react";
import { Col, Form, Row } from "react-bootstrap";
import { BsUpload } from "react-icons/bs";
import { createCertificateAssetAPI, TEMPLATE_ASSETS_BASE_URL } from "../api/api";

// Resolves the logo image for a footer company: an uploaded asset if one is
// selected, otherwise the bundled default for that slot.
export const footerLogoUrl = (company, footerAssets = []) => {
  const saved = footerAssets.find((asset) => String(asset.id) === String(company.asset_id));
  return saved?.image_url || `${TEMPLATE_ASSETS_BASE_URL}/footer-logo-${company.key}.jpg`;
};

export const footerToLogos = (companies = [], footerAssets = []) =>
  companies.map((company) => ({
    key: company.key,
    name: company.name,
    url: company.url,
    imageUrl: footerLogoUrl(company, footerAssets),
  }));

/**
 * Edits the seven footer companies (website + replaceable logo) and the
 * contact lines. `value` = { companies, website, email, gmail }.
 */
export default function FooterEditor({ value, onChange, footerAssets, token, onAssetCreated, onError }) {
  const companies = value.companies || [];

  const updateCompany = (index, patch) => {
    onChange({
      companies: companies.map((company, companyIndex) =>
        companyIndex === index ? { ...company, ...patch } : company
      ),
    });
  };

  const replaceLogo = async (index, file) => {
    if (!file) return;
    const company = companies[index];
    const res = await createCertificateAssetAPI({ asset_type: "footer", name: company.name, file }, token);
    if (res.success) {
      onAssetCreated(res.asset);
      updateCompany(index, { asset_id: res.asset.id });
    } else if (onError) {
      onError(res.message || "Failed to upload logo.");
    }
  };

  return (
    <>
      <div className="cc-logo-grid">
        {companies.map((company, index) => (
          <div className="cc-logo-card" key={company.key || index}>
            <img src={footerLogoUrl(company, footerAssets)} alt={company.name} />
            <strong>{company.name}</strong>
            <Form.Control
              className="cp-form-control"
              value={company.url || ""}
              placeholder="https://"
              onChange={(e) => updateCompany(index, { url: e.target.value })}
            />
            <label className="cp-edit-btn cc-logo-upload">
              <BsUpload size={13} /> Change logo
              <input
                type="file"
                accept=".png,.jpg,.jpeg"
                hidden
                onChange={(e) => { replaceLogo(index, e.target.files?.[0]); e.target.value = ""; }}
              />
            </label>
          </div>
        ))}
      </div>
      <Row>
        <Col md={4}>
          <Form.Group className="mb-3">
            <Form.Label className="cp-form-label">Website</Form.Label>
            <Form.Control className="cp-form-control" value={value.website || ""} onChange={(e) => onChange({ website: e.target.value })} />
          </Form.Group>
        </Col>
        <Col md={4}>
          <Form.Group className="mb-3">
            <Form.Label className="cp-form-label">Email</Form.Label>
            <Form.Control className="cp-form-control" value={value.email || ""} onChange={(e) => onChange({ email: e.target.value })} />
          </Form.Group>
        </Col>
        <Col md={4}>
          <Form.Group className="mb-3">
            <Form.Label className="cp-form-label">Gmail</Form.Label>
            <Form.Control className="cp-form-control" value={value.gmail || ""} onChange={(e) => onChange({ gmail: e.target.value })} />
          </Form.Group>
        </Col>
      </Row>
    </>
  );
}
